import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ChooseTableComponent } from '../choose-table/choose-table.component';
import { ReturnAllDateComponent } from '../return-all-date/return-all-date.component';

@Component({
  selector: 'app-request-list',
  templateUrl: './request-list.component.html',
  styleUrls: ['./request-list.component.css']
})
export class RequestListComponent implements OnInit {

  public menu_item_id = '73';
  public add_auth; edit_auth; del_auth;

  model = { 'table_name': 'qutation', 'fromDate': new Date(), 'toDate': new Date(), 
    'branch_id': '0', 'title': '' };

  private dp = [];
  
  displayedColumns = ['table_number', 'qutation_no', 'qutation_date', 'customer_name', 'mobile', 
    'final_total', 'qutation_status', 'view', 'change_table', 'edit']; //, 'delete'
  // , 'print'
  displayedColumns2 = ['table_number', 'qutation_no', 'qutation_date', 'customer_name', 'mobile', 
    'final_total', 'qutation_status'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild('TABLE') table: ElementRef;

  list_type = 'pending';
  tableClicked = false;

  branchList = [];

  from_date = ''; to_date = '';
  From_Date; To_Date;
  From_Date_Msg; To_Date_Msg;
  Pending_Request; Closed_Request;
  Success_Msg; Error_Msg;
  Same_Table_Msg; Busy_Table_Msg; Ret_No_Msg;
  Cancel_Invoice_Msg; Ret_All_Msg;
  Returned_Request;
  // Del_Msg; 

  tableDialogRef: MatDialogRef<ChooseTableComponent>;
  returnDateDialogRef: MatDialogRef<ReturnAllDateComponent>;

  constructor(private utils: Utils, private applicationConstants: ApplicationConstants,
    private queryList: QueryList, public translate: TranslateService, private router: Router,
    public dialog: MatDialog) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Requests').subscribe((res: string) => {
      this.model.title = res;
    });

    translate.get('From_Date').subscribe((res: string) => {
      this.From_Date = res;
    });

    translate.get('To_Date').subscribe((res: string) => {
      this.To_Date = res;
    });

    translate.get('Pending_Request').subscribe((res: string) => {
      this.Pending_Request = res;
    });

    translate.get('Closed_Request').subscribe((res: string) => {
      this.Closed_Request = res;
    });

    translate.get('Returned_Request').subscribe((res: string) => {
      this.Returned_Request = res;
    });

    // translate.get('Del_Msg').subscribe((res: string) => {
    //   this.Del_Msg = res;
    // });
    
    translate.get('Ret_All_Msg').subscribe((res: string) => {
      this.Ret_All_Msg = res;
    });

    translate.get('Ret_No_Msg').subscribe((res: string) => {
      this.Ret_No_Msg = res;
    });

    translate.get('Cancel_Invoice_Msg').subscribe((res: string) => {
      this.Cancel_Invoice_Msg = res;
    });

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

    translate.get('Same_Table_Msg').subscribe((res: string) => {
      this.Same_Table_Msg = res;
    });

    translate.get('Busy_Table_Msg').subscribe((res: string) => {
      this.Busy_Table_Msg = res;
    });
  }

  ngOnInit() {
    this.add_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.ADD_AUTH);
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);
    this.del_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.DELETE_AUTH);

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'الكل', 'branch_name_en': 'All' });

        this.search(this.list_type);
      });
  }

  search(type) {
    this.list_type = type;
    this.dp = [];

    if (this.model['fromDate'] == undefined || this.model['fromDate'].toString() == '') {
      alert(this.From_Date_Msg);
      return;
    }

    if (this.model['toDate'] == undefined || this.model['toDate'].toString() == '') {
      alert(this.To_Date_Msg);
      return;
    }

    this.from_date = this.model['fromDate'].getFullYear() + "-" + (this.model['fromDate'].getMonth() + 1) + "-" +
      this.model['fromDate'].getDate() + ' 00:00:00';
    this.to_date = this.model['toDate'].getFullYear() + "-" + (this.model['toDate'].getMonth() + 1) + "-" +
      this.model['toDate'].getDate() + ' 23:59:59';

    let condition = " WHERE `qutation`.`qutation_date` BETWEEN '" + this.from_date + "' AND '" + this.to_date + "'";
    let field = "";
    let fromTable = '';
    if (type == 'pending') {
      this.displayedColumns = ['table_number', 'qutation_no', 'qutation_date', 'customer_name', 'mobile', 'final_total',
        'qutation_status', 'view', 'change_table', 'edit'];   // , 'delete', 'print'
      this.displayedColumns2 = ['table_number', 'qutation_no', 'qutation_date', 'customer_name', 'mobile', 'final_total',
        'qutation_status'];

      condition += " AND `qutation`.`status` = '2'";
    }
    else if (type == 'closed') {
      this.displayedColumns = ['table_number', 'qutation_no', 'qutation_date', 'customer_name', 'mobile', 'final_total',
        'invoice_no', 'qutation_status', 'view', 'del'];  // , 'edit', 'delete', 'print'
      this.displayedColumns2 = ['table_number', 'qutation_no', 'qutation_date', 'customer_name', 'mobile', 'final_total',
        'invoice_no', 'qutation_status'];

      field = ", `invoice`.`invoice_no`, `invoice`.`invoice_date`, `invoice`.`acct_number`, `invoice`.`payment_method`, `invoice`.`tax_acct`";
      fromTable = ", `invoice`";
      condition += " AND `qutation`.`status` != '2' AND `qutation`.`qutation_no` = `invoice`.`qutation_no`";
    }

    if (this.model['branch_id'] != '0')
      condition += " AND `qutation`.`branch_id` = '" + this.model['branch_id'] + "'";

    else if (this.model['branch_id'] == '0') {
      let list_length = this.branchList.length;
      if (list_length == 2) 
        condition += " AND `qutation`.`branch_id` = '" + this.branchList[1]['branch_id'] + "'";
      else {
        let index = 1;
        condition += " AND `qutation`.`branch_id` IN (";
        this.branchList.forEach(element => {
          if (element.branch_id != '0') {
            if (index < list_length)
              condition += " '" + element.branch_id + "',";
            else if (index == list_length)
              condition += " '" + element.branch_id + "'";
          }
          index++;
        });
        condition += ")";
      }
      
    }

    let query = "SELECT `qutation`.*, (CASE WHEN `qutation`.`customer_no` != '' THEN " +
      "(SELECT `customer`.`customer_name` FROM `customer` WHERE `customer`.`acct_number` = `qutation`.`customer_no`) " +
      "ELSE `qutation`.`customer_name` END) AS 'customer_name', (CASE WHEN `qutation`.`customer_no` != '' THEN " +
      "(SELECT `customer`.`mobile` FROM `customer` WHERE `customer`.`acct_number` = `qutation`.`customer_no`) " +
      "ELSE '' END) AS 'mobile', (CASE WHEN `qutation`.`serv_table_id` != '' THEN (SELECT " +
      "`serv_table`.`table_number` FROM `serv_table` WHERE `serv_table`.`serv_table_id` = `qutation`.`serv_table_id`) " +
      "ELSE '' END) AS 'table_number'" + field + " FROM `qutation`" + fromTable + condition;
    // console.log(query);
    let obj = { cmd: 'getList', query: query };

    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.dp = data.data['list'];

        this.dp.forEach(element => {
          element.final_total = ((Number(element.total) + Number(element.tax) - Number(element.discount))).toFixed(2);
          if (element.status == 2)
            element.qutation_status = this.Pending_Request;
          else if (element.status == 1)
            element.qutation_status = this.Closed_Request;
          else if (element.status == 3)
            element.qutation_status = this.Returned_Request;
        });

        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
      });
  }

  showTables() {
    this.tableClicked = true;
    this.tableDialogRef = this.dialog.open(ChooseTableComponent, {
      hasBackdrop: false,
      data: { 'dialog_type': 'open_request' }
    });
    this.tableDialogRef
      .afterClosed()
      .subscribe(result => {
        this.tableClicked = false;

        if (result['serv_table_id'] != undefined && result['qutation_no'] != undefined) {
          if (result['qutation_no'] != '') {
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(['sub_menu/1/sale_point/' + result['qutation_no']]); // navigate to same route
            });
          }
          else {
            this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
              this.router.navigate(['sub_menu/1/sale_point/null/' + result['serv_table_id']]); // navigate to same route
            });
          }
        }
        // if (result['table_status'] != undefined && result['table_status'] == 'FREE') 

        // this.model.serv_table_id = result['serv_table_id'];
      });
  }

  print(row = null) {
    let html_data = '';
    let form = (document.getElementById('form1') as HTMLFormElement);

    if (row == null) {
      html_data = '<table cellpadding="8" cellspacing="0"><tr>';
      html_data += '<td width="33%"> ' + this.From_Date + ': ' + this.from_date + '</td>';
      html_data += '<td width="33%">  ' + this.To_Date + ': ' + this.to_date + '</td>';
      html_data += '<td width="33%"> </td></tr>';
      html_data += '</table>';

      let table = (document.getElementById('request_table2') as HTMLTableElement);
      html_data += this.utils.printReport(html_data, [{ table: table }], form, 'PDF');
    }
  }

  exportToExcel() {
    this.utils.exportToExcel(this.table.nativeElement, this.model.title);
  }

  returnInvoice(row) {

    let dialog_data = [{ 'invoice_no': row.invoice_no, 'invoice_date': row.invoice_date }];
    this.returnDateDialogRef = this.dialog.open(ReturnAllDateComponent, {
      hasBackdrop: false,
      data: dialog_data
    });
    this.returnDateDialogRef
      .afterClosed()
      .subscribe(result => {
        if (result != null && result['op_type'] == 'success') {
          this.utils.returnSaleInvoice(row, result['return_date'], this);
        }
      });

    // if (confirm(this.Ret_All_Msg)) 
    //   this.utils.returnSaleInvoice(row, this);

      // let return_invoice_no = this.utils.returnSaleInvoice(row);
      // if (return_invoice_no != '') {
      //   alert(this.Cancel_Invoice_Msg + this.Ret_No_Msg + return_invoice_no);
      //   this.getRequestList(this.list_type);
      // }
      // else 
      //   alert(this.Error_Msg);
    
  }

  // deleteReq(row) {
  //   if (confirm(this.Del_Msg)) {

  //     let values = [];
  //     values.push({ 'table_name': this.model['table_name'], 'qutation_no': row.qutation_no });
  //     values.push({ 'table_name': 'qutation_item', 'qutation_no': row.qutation_no });

  //     if (row.invoice_no != undefined) {
  //       values.push({ 'table_name': 'invoice', 'invoice_no': row.invoice_no });
  //       values.push({ 'table_name': 'invoice_item', 'invoice_no': row.invoice_no });
  //       values.push({ 'table_name': 'inv_payment_method', 'invoice_no': row.invoice_no });
  //     }

  //     let obj;
  //     obj = { cmd: 'deleteRec', values: values };

  //     this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
  //       .subscribe(data => {
  //         this.applicationConstants.appComp.hideBusyCursor();
  //         //console.log(data);
  //         if (data.status['type'] == 'success') {
  //           values = [{ 'table_name': 'serv_table', 'qutation_no': '', 'res_status': '1' }];
  //           let where = [{ 'qutation_no': row.qutation_no }];
  //           obj = { cmd: 'update', values: values, where: where };

  //           this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
  //             .subscribe(data => {
  //               this.applicationConstants.appComp.hideBusyCursor();

  //               if (data.status['type'] == 'success') {
  //                 alert(this.Success_Msg);
  //                 this.getRequestList(this.list_type);
  //               }
  //               else {
  //                 alert(this.Error_Msg);
  //               }
  //             });
  //         }
  //         else {
  //           alert(this.Error_Msg);
  //         }
  //       });
  //   }
  // }

  changTable(row) {
    this.tableClicked = true;
    this.tableDialogRef = this.dialog.open(ChooseTableComponent, {
      hasBackdrop: false,
      data: { 'dialog_type': 'change_table', 'serv_table_id': row.serv_table_id }
    });
    this.tableDialogRef
      .afterClosed()
      .subscribe(result => {
        this.tableClicked = false;
        let values = [], obj;


        if (result['serv_table_id'] != undefined && result['qutation_no'] != undefined) {
          if (result['serv_table_id'] == row.serv_table_id)
            alert(this.Same_Table_Msg);
          else {
            if (result['qutation_no'] == '') {
              // empty old reserved table
              values.push({
                'table_name': 'serv_table', 'qutation_no': '', 'flag': 'update',
                'key': 'serv_table_id', 'serv_table_id': row.serv_table_id, 'res_status': '1'
              });

              // reserve the new table
              values.push({
                'table_name': 'serv_table', 'qutation_no': row.qutation_no, 'flag': 'update',
                'key': 'serv_table_id', 'serv_table_id': result['serv_table_id'], 'res_status': '2'
              });
              values.push({
                'table_name': 'qutation', 'qutation_no': row.qutation_no, 'flag': 'update',
                'key': 'qutation_no', 'serv_table_id': result['serv_table_id']
              });
              // console.log(values);

            }
            else if (result['qutation_no'] != '') {
              if (confirm(this.Busy_Table_Msg)) {
                // exchange tables
                values.push({
                  'table_name': 'serv_table', 'qutation_no': result['qutation_no'], 'flag': 'update',
                  'key': 'serv_table_id', 'serv_table_id': row.serv_table_id
                });
                values.push({
                  'table_name': 'qutation', 'qutation_no': result['qutation_no'], 'flag': 'update',
                  'key': 'qutation_no', 'serv_table_id': row.serv_table_id
                });
                values.push({
                  'table_name': 'serv_table', 'qutation_no': row.qutation_no, 'flag': 'update',
                  'key': 'serv_table_id', 'serv_table_id': result['serv_table_id']
                });
                values.push({
                  'table_name': 'qutation', 'qutation_no': row.qutation_no, 'flag': 'update',
                  'key': 'qutation_no', 'serv_table_id': result['serv_table_id']
                });

                // console.log(values);

              }
            }

            if (values.length > 0) {
              obj = { cmd: 'updateAdv', values: values };

              this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
                .subscribe(data => {
                  this.applicationConstants.appComp.hideBusyCursor();

                  if (data.status['type'] == 'success') {
                    alert(this.Success_Msg);
                    this.search(this.list_type);
                  }
                  else
                    alert(this.Error_Msg);

                });
            }
          }
        }

      });

  }

}
